import { ThreeDRotationOutlined } from '@mui/icons-material'

import { TenantPermission } from '@tabeeb/enums'
import Routes from '@tabeeb/routes'
import { useSelector } from '@tabeeb/store'
import { hasTenantPermission } from '@tabeeb/modules/permissions/selectors'
import { getIsPointCloudModelsEnabled } from '@tabeeb/modules/appConfigState/selectors'
import { NavbarItem } from '@collaborate-health/uikit'

const ThreeDimensionalModelsTab = ({ ...rest }) => {
  const display = useSelector(
    (state) =>
      hasTenantPermission(state, TenantPermission.ThreeDimensionalModelsManagement) &&
      getIsPointCloudModelsEnabled(state)
  )
  if (!display) {
    return null
  }

  return <NavbarItem name='3D Models' href={Routes.threeDimensionalModels} icon={<ThreeDRotationOutlined />} />
}

export default ThreeDimensionalModelsTab

